import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AcceptCookieComponent} from './accept-cookie.component';
import {MatIconModule} from '@angular/material/icon';
import {FormsModule} from '@angular/forms';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatListModule} from '@angular/material/list';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatStepperModule} from '@angular/material/stepper';
import {MatLineModule} from '@angular/material/core';



@NgModule({
  declarations: [
    AcceptCookieComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatListModule,
    MatIconModule,
    MatCheckboxModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatStepperModule,
    MatLineModule,

  ],
  exports: [
    AcceptCookieComponent
  ]
})
export class AcceptCookieModule { }
